import React from "react";
import { useSearchParams } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
// import processingPaymentImg from "../../Assets/PaymentProcessingImg.png";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onValidatePayment } from "../../Store/Slices/validatePaymentSlice";
import { useOrderFlow } from "../Card/hooks/useOrderFlow";
import Loader from "../Loader/Loader";
import { OrderData } from "../Utility/Utility";
import { onPendingOrderReset, onUpdateOrderReset } from "../../Store/Slices/orderSlice";
import { set } from "react-hook-form";

const ProcessingPaymentHosted = () => {
  const {validatePaymentData} = useSelector((state) => state.validatePaymentReducer);
  const translation = getTranslationData();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [params] = useSearchParams();
  const ref = params.get("src");
  const [isLoading, setLoading] = useState(false);
  const hasUpdatedOrder = useRef(false);

  // Minimal getOrderPayload helper used by `useOrderFlow`
  const getOrderPayload = () => {
    try {
      const str = sessionStorage.getItem('OrderPayloadSession');
      return str ? JSON.parse(str) : null;
    } catch (e) {
      return null;
    }
  };

  const existingTransactionStrHook = sessionStorage.getItem('OrderPayloadSession_post');
  const existingTransactionDataHook = existingTransactionStrHook ? JSON.parse(existingTransactionStrHook) : null;
  const orderData = existingTransactionDataHook;
  
  // Use the order flow hook with minimal props so we can reuse its update helper
  const { handleUpdateOrder } = useOrderFlow({
    dispatch,
    getOrderPayload,
    orderData: {
      postOrderData: [orderData],
    },
    flow2: false,
    totalPayableAmount: 0,
    setLoading: () => {},
    translation,
  });


  useEffect(() => {
    const payload = {
      paymentGuId: ref
    };
    dispatch(onValidatePayment(payload));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref]);

  useEffect(() => {
    if (!validatePaymentData?.PaymentResponse || hasUpdatedOrder.current) return;

    // Delegate update behavior to useOrderFlow's handler so logic stays consistent
    hasUpdatedOrder.current = true;
    const transaction = JSON.parse(validatePaymentData?.PaymentResponse); 
    try {
      setLoading(true);
      if(transaction?.status?.toLowerCase() === "success") {
        handleUpdateOrder(transaction, true, false, false, false, false, true);
    }else if(transaction?.status?.toLowerCase() === "failure" && transaction?.unmappedstatus?.toLowerCase() === "userCancelled"?.toLocaleLowerCase()) {
        handleUpdateOrder(undefined, true, false, true, false, "failed");
      }else {
        handleUpdateOrder(undefined, true, false, false, true, "failed");
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('handleUpdateOrder failed from ProcessingPayment', e);
    } 
  }, [validatePaymentData, handleUpdateOrder]);

  
  const currentOrderData = OrderData();
  useEffect(() => {
    const errorCode = currentOrderData?.errorCode;
    const updatedOrderData = currentOrderData?.updatedOrderData || {};
    const orderStatus = updatedOrderData?.orderStatus?.trim()?.toLowerCase();

    if (errorCode === "1461" || errorCode === "1462") {
      setLoading(false);
      dispatch(onPendingOrderReset());
      sessionStorage.removeItem("OrderPayloadSession");
      sessionStorage.removeItem("OrderPayloadSession_post");
      navigate("/processing-payment");
      return;
    }

    if (orderStatus === "completed") {
      setLoading(false);
      dispatch(onUpdateOrderReset());
      navigate("/order-confirmation", {
        state: updatedOrderData,
      });
      return;
    }

    if (orderStatus === "failed") {
      setLoading(false);
      dispatch(onUpdateOrderReset());
      sessionStorage.removeItem("OrderPayloadSession");
      sessionStorage.removeItem("OrderPayloadSession_post");
      navigate("/order-confirmation", {
        state: updatedOrderData,
      });
      return;
    }

    if (orderStatus === "pending") {
      setLoading(false);
      dispatch(onUpdateOrderReset());
      dispatch(onPendingOrderReset());
      sessionStorage.removeItem("OrderPayloadSession");
      sessionStorage.removeItem("OrderPayloadSession_post");
      navigate("/order-processing", {
        state: { orderDetails: true }
      });
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrderData]);



  return (
    <>
    {isLoading && <Loader />}
    </>
  );
};

export default ProcessingPaymentHosted;
